// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ff2c0c8","491":"9d82b73d","560":"a93752e7"}[chunkId] + ".chunk.js";
};